// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/_css-loader@5.2.0@css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading[data-v-416235cf]{top:0;height:100%;background:hsla(0,0%,100%,.6)}.loading[data-v-416235cf],.loading .van-loading[data-v-416235cf]{position:fixed;left:0;z-index:9999;width:100%}.loading .van-loading[data-v-416235cf]{top:50%;margin-top:-.4rem;text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
